import { emitEvent } from '@faceup/devtools'
import { usePostHog, useTrack } from '@faceup/posthog'
import { useCallback, useEffect } from 'react'
import { getDeviceInfo } from '../locales'
import type { FollowUpTrackingEvents } from './analytics.types'

const ALLOW_DEVTOOLS = import.meta.env.VITE_ENVIRONMENT !== 'production'

export const useTrackPlatform = () => {
  const posthog = usePostHog()

  useEffect(() => {
    const fetchPlatform = async () => {
      const { platform } = await getDeviceInfo()
      const properties = { platform: platform.toLowerCase() }
      posthog.setPersonProperties(properties)
      if (ALLOW_DEVTOOLS) {
        emitEvent('analytics', ['$set', properties])
      }
    }

    fetchPlatform()
  }, [posthog])
}

const useAnalytics = () => {
  const track = useTrack<FollowUpTrackingEvents>()

  const wrappedTrack = useCallback(
    ((...args: unknown[]) => {
      ;(track as (...a: unknown[]) => void)(...args)
      if (ALLOW_DEVTOOLS) {
        emitEvent('analytics', args)
      }
    }) as typeof track,
    []
  )

  return { track: wrappedTrack }
}

export default useAnalytics
